<template>
  <div>
    <div>
      <label for="">Bank Name</label>
      <el-input placeholder="Please input" v-model="bankName"></el-input>
    </div>
    <div class="pt-3">
      <label for="">Bank Account</label>
      <el-input placeholder="Please input" v-model="accNumber"></el-input>
    </div>
    <div class="pt-3">
      <label for="">IFSC Code</label>
      <el-input placeholder="Please input" v-model="ifsc"></el-input>
    </div>
    <div class="pt-5 flex justify-center" @click="addData">
      <el-button class="bg-primary text-white">Save</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      bankName: "",
      accNumber: "",
      ifsc: "",
    };
  },
  methods: {
    async addData() {
      let payload = {
        volunteerId: this.volunteer[0]._id,
        userId: this.volunteer[0].userId._id,
        bankName: this.bankName,
        accountNumber: this.accNumber,
        IFSCCode: this.ifsc,
      };
      try {
        const data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        this.bankName = "";
        this.accNumber = "";
        this.ifsc = "";
        this.$router.push({ name: "earning-table" });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("respitecare", {
      volunteer: "get_volunteerbyuserId",
      get_volbyid: "get_volbyid",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
};
</script>

<style></style>
